import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { twMerge } from 'tailwind-merge'

export const HeaderSkeleton = () => {
  return (
    <div
      className={twMerge(
        'relative col-start-1 col-end-3 flex items-center justify-between',
        'border-border200 border-b bg-bgPrimaryBase px-7 py-1',
        'z-header',
      )}
    >
      <div className="flex items-center gap-4">
        <Skeleton width={32} height={32} borderRadius={4} />
        <div className="flex gap-2">
          <Skeleton width={24} height={24} borderRadius={4} />
          <Skeleton width={24} height={24} borderRadius={4} />
        </div>
        <div className="flex gap-2">
          <Skeleton width={80} height={32} borderRadius={6} />
          <Skeleton width={80} height={32} borderRadius={6} />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Skeleton width={24} height={24} borderRadius={4} />
        <Skeleton width={24} height={24} borderRadius={4} />
        <Skeleton width={64} height={32} borderRadius={6} />
        <Skeleton width={56} height={32} borderRadius={6} />
      </div>
    </div>
  )
}
